import { Link } from 'gatsby'
import styled, { css } from 'styled-components'
import { Media, mbSize } from '../../theme'

/** $scrolled:
 * true：白底实心 header；
 * false：仅首页/九个 solution 页使用透明 + 浅色文案，其余还是白底实心 */
export const HeaderWrapper = styled.div<{
  $scrolled?: boolean
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  width: 100%;
  background: ${({ $scrolled }) => ($scrolled ? '#ffffff' : 'transparent')};
  backdrop-filter: ${({ $scrolled }) => ($scrolled ? 'none' : 'blur(10px)')};
  -webkit-backdrop-filter: ${({ $scrolled }) => ($scrolled ? 'none' : 'blur(10px)')};
  border-bottom: ${({ $scrolled }) => ($scrolled ? '1px solid #cccccc' : '1px solid transparent')};
  box-sizing: border-box;
  z-index: 10000;
  position: fixed;
  top: 0px;
  margin-bottom: -70px;
  min-width: 1280px;
  color: #64748b;
  transition:
    background 0.2s ease,
    backdrop-filter 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;
  ${({ $scrolled }) =>
    !$scrolled &&
    css`
      color: #ffffff;
      ${NavLink} {
        color: #ffffff;
      }
      #index_sign_in,
      .console-link,
      .header-user-info-item,
      .header-locale-text {
        color: #ffffff;
      }
      #index_register {
        background: #f3512b;
      }
      .header-menu-icon {
        line {
          stroke: #ffffff;
        }
      }
      .header-close-icon,
      .header-locale-icon,
      .header-down-arrow-icon {
        path {
          stroke: #ffffff;
        }
      }
    `}
  ${Media.lessThan(Media.small)} {
    margin-bottom: unset;
    position: fixed;
    justify-content: space-between;
    top: unset;
    height: ${mbSize(120)};
    padding: 0 ${mbSize(48)};
    border-bottom: none;
    min-width: unset;
  }
`

export const HeaderLeftWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  ${Media.lessThan(Media.small)} {
    padding-left: unset;
  }
`

export const HeaderRightWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding-right: 20px;
  height: 100%;
  margin-left: 74px;
  ${Media.lessThan(Media.xxxlarge)} {
    padding-right: 10px;
    gap: 12px;
  }
  ${Media.lessThan(Media.small)} {
    padding-right: unset;
    gap: unset;
    margin-left: unset;
  }
`

export const UserActionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 28px;
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`

/* Figma Line 7: 1px #E5E5E5, height 32px between locale and auth */
export const HeaderVerticalDivider = styled.div<{ $scrolled?: boolean }>`
  width: 1px;
  height: 32px;
  background: ${({ $scrolled }) => ($scrolled ? '#e5e5e5' : 'rgba(255, 255, 255, 0.5)')};
  flex-shrink: 0;
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 40px 0 0;
  height: 100%;
  img {
    width: 140px;
    height: 30px;
  }
  ${Media.lessThan(Media.xxxlarge)} {
    padding: 0 20px 0 20px;
  }
  ${Media.lessThan(Media.small)} {
    padding: unset;
    width: ${mbSize(280)};
    height: ${mbSize(60)};
    img {
      width: ${mbSize(280)};
      height: ${mbSize(60)};
    }
  }
`

export const NavBarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  height: fit-content;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`

const commonLink = css<{ $isActive: boolean }>`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  font-family: Inter, system-ui, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
  height: 70px;
  padding: 0;
  transition:
    background 0.2s,
    color 0.2s;
  &:hover {
    color: #f3512b;
  }
  ${Media.lessThan(Media.xxxlarge)} {
    padding: 0 4px;
  }
`

export const NavLink = styled(Link)<{ $isActive: boolean }>`
  ${commonLink}
  color: #64748b;
`

export const HeaderButton = styled.button<{
  $horizontalPadding: number
  $height: number
  $isRegister?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Inter, system-ui, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1;
  /* Figma Register: padding 12px 20px, radius 4px, fill #000815 */
  padding: ${({ $isRegister, $horizontalPadding, $height }) =>
    $isRegister && $height >= 36 ? '12px 20px' : `0 ${$horizontalPadding}px`};
  height: ${({ $isRegister, $height }) => ($isRegister && $height >= 36 ? 'auto' : `${$height}px`)};
  min-height: ${({ $height }) => `${$height}px`};
  border-radius: ${({ $isRegister }) => ($isRegister ? '4px' : '18px')};
  color: ${({ $isRegister }) => ($isRegister ? '#ffffff' : '#64748b')};
  transition: all 0.2s;
  background: ${({ $isRegister }) => ($isRegister ? '#000815' : 'transparent')};
  margin-left: ${({ $isRegister }) => (!$isRegister ? '0' : 'unset')};
  white-space: nowrap;
  text-decoration: none;
  box-sizing: border-box;
  &:hover {
    background: ${({ $isRegister }) => ($isRegister ? '#001a33' : 'none')};
    border-color: transparent;
  }
`

export const NavDropDownWrapper = styled.div<{ $isActive: boolean; $left: number }>`
  ${commonLink}
  cursor: pointer;
  position: relative;
  > div.navDropDown {
    visibility: hidden;
    position: absolute;
    left: ${({ $left }) => `${$left}px`};
    top: 70px;
    background: #222222;
  }
  &:hover {
    div.navDropDown {
      visibility: visible;
    }
  }
`

export const NavDropDownItem = styled.div<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0 20px;
  color: #fff;
  width: 100%;
  white-space: nowrap;
  transition: background 0.3s;
  background: ${({ $isActive }) => ($isActive ? '#181818' : '#222222')};
  &:hover {
    background: #181818;
    border-bottom: 2px solid #f3512b;
  }
`

export const NavDropdownTrigger = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  user-select: none;
  > svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    display: block;
    transition: transform 0.2s ease;
  }
`

export const LightNavDropDownWrapper = styled.div<{
  $isActive: boolean
  $panelMinWidth?: number
  $panelLeft?: string
}>`
  ${commonLink}
  position: relative;
  &:hover ${NavDropdownTrigger} > svg {
    transform: rotate(180deg);
  }
  > div.lightNavDropDown {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    left: ${({ $panelLeft }) => $panelLeft || '50%'};
    top: 70px;
    background: #ffffff;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.08);
    min-width: ${({ $panelMinWidth }) => ($panelMinWidth ? `${$panelMinWidth}px` : '200px')};
    padding: 30px;
    box-sizing: border-box;
    z-index: 10001;
    transform: translateX(-50%);
    transition: opacity 0.15s ease;
  }
  &:hover {
    > div.lightNavDropDown {
      visibility: visible;
      opacity: 1;
    }
  }
`

export const LightDropDownTitle = styled.div`
  font-family: Inter, system-ui, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.21;
  color: #0f172a;
  margin: 16px 0 26px 16px;
`

export const ResourceTitle = styled(LightDropDownTitle)`
  margin-bottom: 20px;
`

export const LocalePanelTitle = styled(LightDropDownTitle)`
  margin: 16px 0 20px 16px;
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`

export const LightDropDownSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const ProductsLightDropDownSection = styled(LightDropDownSection)`
  gap: 12px;
`

export const SupportDropdownSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 24px;
`

export const LightDropDownRow = styled.a<{ $emphasis?: boolean; $highlight?: boolean }>`
  display: flex;
  align-items: center;
  height: 52px;
  font-family: Inter, system-ui, sans-serif;
  font-size: 14px;
  line-height: 1.21;
  color: #0f172a;
  text-decoration: none;
  padding: 0 0 0 15px;
  border-radius: 4px;
  background: ${({ $highlight }) => ($highlight ? '#fff0ec' : 'transparent')};
  transition: background 0.15s;
  white-space: nowrap;
  &:hover {
    background: #fff0ec;
    color: #0f172a;
  }
  &.products-main-link:hover svg rect {
    fill: #ffffff;
  }
  ${Media.lessThan(Media.small)} {
    padding: 0;
    height: fit-content;
    font-size: ${mbSize(24)};
    background: transparent;
    &:hover {
      background: transparent;
    }
    &.products-main-link svg {
      width: ${mbSize(48)};
      height: ${mbSize(48)};
    }
    img {
      width: ${mbSize(24)};
      height: ${mbSize(24)};
      margin-right: ${mbSize(12)};
    }
  }
`

export const ResourceDropDownSection = styled(LightDropDownSection)`
  &.right {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    column-gap: 24px;
  }
`

export const LightDropDownColumns = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 36px;
`

export const LightDropDownColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

export const ResourceDropDownColumn = styled(LightDropDownColumn)`
  min-width: 230px;
  gap: 0;
`

export const SolutionsColumn = styled(LightDropDownColumn)`
  width: 200px;
  gap: unset;
`

export const LightDropDownDivider = styled.div`
  width: 0.5px;
  align-self: center;
  height: 195px;
  background: #cccccc;
  flex-shrink: 0;
`

export const LightSupportFooter = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  bottom: -50px;
  right: 0;
  height: 50px;
  background: #f3512b;
  border-radius: 0 0 8px 8px;
  font-family: Inter, system-ui, sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
  text-decoration: none;
  box-sizing: border-box;
  &:hover {
    background: #e8482b;
    color: #ffffff;
  }
`

export const LocaleMenuWrapper = styled.div<{ $show: boolean }>`
  height: 70px;
  position: relative;
  cursor: pointer;
  color: #64748b;
  user-select: none;
  font-family: Inter, system-ui, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.143;
  transition: all 0.2s;
  ${({ $show }) =>
    $show &&
    css`
      color: #f3512b;
    `};
  z-index: 10000;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(28)};
    height: ${mbSize(120)};
    margin: unset;
  }
`

/* Figma 1690:1320 多语言: 白底, 标题 Language, 列表 32px 间距 */
export const LocaleItemsWrapper = styled.div<{ $show: boolean }>`
  width: max-content;
  min-width: 100%;
  visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};
  position: absolute;
  left: 50%;
  top: 100%;
  background: #ffffff;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.08);
  padding: 30px;
  box-sizing: border-box;
  transform: translate(-50%, 0);
  z-index: 10001;
  ${Media.lessThan(Media.small)} {
    border-radius: 0;
    box-shadow: none;
    padding: 0;
  }
`

export const LocaleMenuBackdrop = styled.div`
  display: none;
  ${Media.lessThan(Media.small)} {
    display: block;
    position: fixed;
    top: ${mbSize(120)};
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    /* 低于 HeaderWrapper(10000)，避免 portal 到 body 后盖住语言下拉 */
    z-index: 9999;
  }
`

export const LocaleItem = styled.a<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  padding: 0 0 0 16px;
  width: 140px;
  height: 52px;
  border-radius: 4px;
  font-family: Inter, system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: black;
  text-decoration: none;
  transition: background 0.15s;
  &:hover {
    background: #fff0ec;
    color: #0f172a;
  }
  background: ${({ $isActive }) => ($isActive ? '#fff0ec' : 'transparent')};
  ${Media.lessThan(Media.small)} {
    padding-left: ${mbSize(32)};
    margin: 0;
    width: 100%;
  }
`

/* 多语言左侧图标占位区 — 替换 Figma 导出 SVG 时保持此容器即可 */
export const LocaleTriggerIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  ${Media.lessThan(Media.small)} {
    svg {
      width: ${mbSize(32)};
      height: ${mbSize(32)};
    }
  }
`

/* 下拉箭头单独包一层，避免与左侧图标共用 > svg 样式 */
export const LocaleMenuTriggerArrow = styled.span<{ $show: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 0;
  transition: transform 0.3s;
  transform: ${({ $show }) => ($show ? 'rotate(180deg)' : 'rotate(0deg)')};
  ${Media.lessThan(Media.small)} {
    svg {
      width: ${mbSize(32)};
      height: ${mbSize(32)};
    }
  }
`

export const CurrentLocaleItem = styled.div<{ $show: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .header-locale-text {
    margin: 0 6px;
  }
  ${Media.lessThan(Media.small)} {
    padding-left: ${mbSize(32)};
    .header-locale-text {
      margin: 0 ${mbSize(12)};
    }
  }
`

export const MobileMenuWrapper = styled.div`
  display: none;
  z-index: 10000;
  ${Media.lessThan(Media.small)} {
    display: block;
    margin-left: ${mbSize(56)};
  }
`

export const MenuIconWrapper = styled.div`
  > svg {
    width: ${mbSize(32)};
    height: ${mbSize(32)};
  }
`

export const MobileMenuItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - ${mbSize(120)});
  overflow-y: auto;
  position: absolute;
  top: ${mbSize(120)};
  left: 0;
  background: #ffffff;
  padding: ${mbSize(48)} ${mbSize(48)} ${mbSize(60)};
  width: 100%;
  color: #0f172a;
`

export const MobileMenuItemsDivider = styled.div`
  min-height: 0.5px;
  width: 100%;
  height: 0.5px;
  background: #cccccc;
`

export const commonMobileMenuLink = css`
  font-size: ${mbSize(28)};
  color: #0f172a;
`

export const MobileMenuLink = styled(Link)`
  ${commonMobileMenuLink}
  padding: ${mbSize(40)} 0;
`

export const MobileSecondMenuWrapper = styled.div`
  padding: ${mbSize(40)} 0;
  &:first-child {
    padding-top: 0;
  }
`

export const MobileSecondMenuTitle = styled.div<{ $isActive: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${commonMobileMenuLink}
  > svg {
    transition: all 0.3s;
    transform: ${({ $isActive }) => ($isActive ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
  .header-down-arrow-icon {
    path {
      stroke: #64748b;
    }
  }
`

export const MobileMenuSecondLink = styled.div<{ $isActive?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${mbSize(24)};
  padding: ${mbSize(10)} ${mbSize(8)};
  color: #0f172a;
  background: transparent;
  > svg {
    transition: all 0.3s;
    transform: ${({ $isActive }) => ($isActive ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
  .header-down-arrow-icon {
    path {
      stroke: #64748b;
    }
  }
`

export const MobileSecondMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${mbSize(40)};
  margin: ${mbSize(32)} 0 0 ${mbSize(20)};
`

export const MobileAuthButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${mbSize(40)};
  margin-top: ${mbSize(60)};
`

export const MobileAuthButton = styled.a<{ $variant?: 'signin' | 'register' }>`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${mbSize(32)} 0;
  border-radius: 4px;
  font-family: Inter, system-ui, sans-serif;
  font-weight: 700;
  font-size: ${mbSize(24)};
  line-height: 1;
  text-decoration: none;
  color: #ffffff;
  background: ${({ $variant }) => ($variant === 'register' ? '#f3512b' : '#0f172a')};
`

export const SupportDropDownWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
`

export const SupportDownloadWrapper = styled(Link)`
  position: relative;
  width: 270px;
  height: 160px;
  border-radius: 10px;
  background: linear-gradient(
    285.35deg,
    rgba(243, 81, 43, 0.1) 12.22%,
    rgba(51, 51, 51, 0.2) 89.84%
  );
  padding-left: 20px;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 10px;
    padding: 1px;
    background: linear-gradient(180deg, rgba(51, 51, 51, 0.7) 0%, rgba(245, 92, 30, 0.2) 100%);
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask-composite: exclude;
  }
  &:hover {
    background: linear-gradient(180deg, #333333 0%, rgba(243, 81, 43, 0.6) 100%);
  }
  ${Media.lessThan(Media.small)} {
    display: flex;
    align-items: center;
    width: ${mbSize(650)};
    height: ${mbSize(80)};
    border-radius: ${mbSize(10)};
    margin-bottom: ${mbSize(22)};
    padding-left: ${mbSize(30)};
  }
`

export const FreeIcon = styled.div`
  background: #f3512b;
  position: absolute;
  top: 0;
  right: 0;
  padding: 3px 20px;
  width: fit-content;
  border-radius: 0px 10px 0px 10px;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  ${Media.lessThan(Media.small)} {
    padding: ${mbSize(4.5)} ${mbSize(30)};
    border-radius: 0px ${mbSize(15)} 0px ${mbSize(15)};
    font-size: ${mbSize(24)};
  }
`

export const DownloadTitle = styled.div`
  font-size: 16px;
  font-weight: 800;
  line-height: 20.28px;
  margin-top: 30px;
  color: #fff;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(28)};
    margin-top: unset;
  }
`

export const DownloadItem = styled.div`
  display: flex;
  color: #fff;
  margin-top: 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 17.75px;
  > svg {
    margin-right: 10px;
  }
`

export const SupportCenterDivider = styled.div`
  width: 1px;
  height: 180px;
  margin: 0 30px 0 20px;
  background: #333333;
`

export const SupportRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const SupportItemWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid #333333;
  padding-bottom: 20px;
  margin-bottom: 18px;
`

export const SupportColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const SupportItem = styled.a`
  padding: 10px;
  width: 100%;
  min-width: 180px;
  font-size: 14px;
  font-weight: 400;
  transition: background 0.3s;
  box-sizing: border-box;
  border-bottom: 2px solid transparent;
  color: #fff;
  &:hover {
    border-bottom: 2px solid #f3512b;
    background: #181818;
  }
`

export const SupportContact = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  color: #999999;
  cursor: pointer;
  transition: color 0.3s;
  svg {
    margin-right: 10px;
  }
  &:hover {
    color: #fff;
  }
`

export const Console = styled.a`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  font-family: Inter, system-ui, sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #64748b;
  height: 70px;
  padding: 0 13px;
  transition: background 0.2s;
  margin-right: 0;
`

export const UserMenuWrapper = styled.div<{ $show: boolean }>`
  position: relative;
  cursor: pointer;
  margin-right: 0;
  color: #64748b;
  user-select: none;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  background: transparent;
  z-index: 10000;
`

export const UserInfoItem = styled.div<{ $show: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 70px;
  padding: 0 10px;
  > svg {
    margin-left: 13px;
    transition: all 0.3s;
    transform: ${({ $show }) => ($show ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`

export const UserItemsWrapper = styled.div<{ $show: boolean }>`
  width: max-content;
  min-width: 100%;
  visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};
  position: absolute;
  left: 50%;
  top: 100%;
  background: #ffffff;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.08);
  padding: 30px;
  box-sizing: border-box;
  transform: translate(-50%, 0);
`

export const UserItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0 0 16px;
  width: 140px;
  height: 52px;
  border-radius: 4px;
  font-family: Inter, system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: black;
  text-decoration: none;
  transition: background 0.15s;
  background: transparent;
  &:hover {
    background: #fff0ec;
    color: #0f172a;
  }
`

export const UserAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3512b;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  margin-right: 14px;
  color: #fff;
`

export const Logout = styled.div`
  display: flex;
  align-items: center;
  padding-left: 20px;
  width: 100%;
  height: 48px;
  border-top: 1px solid #333333;
  transition: background 0.3s;
  margin-top: 10px;
  &:hover {
    background: #181818;
  }
`
